//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gql } from 'graphql-tag'
import { sync } from 'vuex-pathify'
import { Language } from '@constants'
import { filter, findIndex } from 'lodash'
import polling from '~/mixins/poll-when-visible'

const NEWS = gql`
  query ($first: Int, $where: ArticleFilterInput, $order: [ArticleSortInput!]) {
    articles(first: $first, where: $where, order: $order) {
      nodes {
        id
        externalId
        date
        title
        slug
        abstract
        imageUrl
        redirectUrl
        edition {
          id
          name
        }
        country {
          id
          name
        }
        region {
          id
          name
        }
        contentType {
          id
          name
          colour
          contentTypeGroup {
            id
            name
          }
        }
      }
    }
  }
`

export default {
  name: 'News',
  mixins: [polling],
  data() {
    return {
      showPlaceholders: true,
      articles: []
    }
  },
  fetchOnServer: true,
  async fetch() {
    this.$store.set('dataFetchingCount/dataFetchingCount', this.$store.get('dataFetchingCount/dataFetchingCount') + 1)
    await this.refresh()
    this.$store.set('dataFetchingCount/dataFetchedCount', this.$store.get('dataFetchingCount/dataFetchedCount') + 1)
  },
  computed: {
    filters: sync('filters'),
    language() {
      return this.$store.get('language/locale') || 'en'
    },
    languageId() {
      return this.language === 'en' ? Language.ENGLISH : Language.DUTCH
    },
    firstArticle() {
      if (!this.articles || this.articles.length === 0) return null
      return this.articles[0]
    },
    secondArticle() {
      if (!this.articles || this.articles.length <= 1) return null
      return this.articles[1]
    }
  },
  watch: {
    'filters.options': {
      async handler() {
        await this.refresh(true)
      },
      deep: true
    },
    async languageId() {
      await this.refresh(true)
    }
  },
  beforeMount() {
    this.startPolling(() => this.refresh(true, false), 5 * 60 * 1000)
  },
  methods: {
    async refresh(purge = false, showPlaceholders = true) {
      this.filters.isLoading = true
      this.showPlaceholders = showPlaceholders

      const where = {
        and: [
          {
            importance: {
              in: ['NEUTRAL', 'VERY_IMPORTANT']
            }
          },
          {
            language: {
              id: {
                eq: this.languageId
              }
            }
          }
        ],
        date: {
          gt: this.$dayjs().startOf('day')
        }
      }

      if (this.filters.options.countryId != null) {
        where.country = {
          id: {
            eq: this.filters.options.countryId
          }
        }
      }

      if (this.filters.options.regionId != null) {
        where.region = {
          id: {
            eq: this.filters.options.regionId
          }
        }
      }

      if (this.filters.options.contentCollectionId != null) {
        where.contentCollectionArticles = {
          some: {
            contentCollectionId: {
              eq: this.filters.options.contentCollectionId
            }
          }
        }
      }

      if (this.filters.options.contentTypeId != null) {
        where.contentType = {
          id: {
            eq: this.filters.options.contentTypeId
          }
        }
      }

      if (!this.filters.options.contentCollectionId && !this.filters.options.contentTypeId) {
        where.contentType = {
          name: {
            in: ['News', 'Commentary', 'Background', 'Profile']
          }
        }
      }

      try {
        const requiredNumber = 11

        // Important articles within past day
        const { data } = await this.$apollo.query({
          query: NEWS,
          fetchPolicy: purge ? 'no-cache' : 'cache-first',
          variables: {
            first: 12,
            where,
            order: [
              {
                date: 'DESC'
              }
            ]
          }
        })

        const articles = data.articles.nodes

        // Only fall back to all articles within past day when the important ones fall short
        if (articles.length < requiredNumber) {
          const additionalWhere = JSON.parse(JSON.stringify(where))
          additionalWhere.and[0].importance.in.push('SLIGHTLY_IMPORTANT')
          delete additionalWhere.date

          const fallback = await this.$apollo.query({
            query: NEWS,
            fetchPolicy: purge ? 'no-cache' : 'cache-first',
            variables: {
              first: requiredNumber,
              where: additionalWhere,
              order: [
                {
                  date: 'DESC'
                }
              ]
            }
          })

          const availableArticles = filter(fallback.data.articles.nodes, (x) => {
            return findIndex(articles, (y) => y.id === x.id) === -1
          })
          articles.push(...availableArticles.slice(0, requiredNumber - articles.length))
        }

        this.articles = articles
      } catch (error) {
        this.handleError(error)
      } finally {
        this.showPlaceholders = false
        this.filters.isLoading = false
      }
    }
  }
}
